import { ICandle } from "../storyFace.types";

const MS_PER_DAY = 24 * 60 * 60 * 1000;

export function computeRemainingTimeMs(candles: ICandle[]): number {
  if (!candles || candles.length === 0) return 0;

  // Sort candles by created_at ascending.
  const sorted = candles.slice().sort(
    (a, b) =>
      new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
  );

  // Build chains: each chain starts at a candle's created_at and extends if subsequent candles fall within the current chain.
  let currentChainStart = new Date(sorted[0].created_at).getTime();
  let currentChainExpiration =
    currentChainStart + sorted[0].candle_lifetime_days * MS_PER_DAY;

  for (let i = 1; i < sorted.length; i++) {
    const candle = sorted[i];
    const candleTime = new Date(candle.created_at).getTime();
    const candleLifetimeMs = candle.candle_lifetime_days * MS_PER_DAY;

    if (candleTime <= currentChainExpiration) {
      // Candle falls within the current chain—extend the chain.
      currentChainExpiration += candleLifetimeMs;
    } else {
      // Candle is created after the current chain expired; start a new chain.
      currentChainStart = candleTime;
      currentChainExpiration = candleTime + candleLifetimeMs;
    }
  }

  const now = Date.now();
  return Math.max(currentChainExpiration - now, 0);
}

export function formatRemainingTime(remainingMs: number, t: (key: string) => string): string {
  const days = Math.floor(remainingMs / MS_PER_DAY);
  const hours = Math.floor((remainingMs % MS_PER_DAY) / (60 * 60 * 1000));
  const minutes = Math.floor((remainingMs % (60 * 60 * 1000)) / (60 * 1000));

  return `${days} ${t("days")} ${hours} ${t("hours")} ${minutes} ${t("minutes")}`;
}

export function getRemainingTimeString(candles: ICandle[], t: (key: string) => string): string {
  const remainingMs = computeRemainingTimeMs(candles);
  return formatRemainingTime(remainingMs, t);
}
